import { DateTime } from "luxon";
import React, { useState } from "react";
import { IoInformationCircleSharp } from "react-icons/io5";
import { toast } from "react-toastify";
import {
  getcrearCalendarioDePagos,
  postcrearCalendarioDePagos,
} from "../../API/ApiCalendarioDePagos";
import { AuthContext } from "../../auth/authContext";
import { useLoading } from "../../contexts/LoadingContext";
import { useUpdatedContext } from "../../contexts/UpdateContext";
const daysMap = [
  "Domingo",
  "Lunes",
  "Martes",
  "Miércoles",
  "Jueves",
  "Viernes",
  "Sábado",
];

const guidVista = "db093ac2-e36c-402c-a7c3-b39a8c2fbc63";

const CalendarioDePagosContratoComponent = (props) => {
  const { user, dispatch } = React.useContext(AuthContext);
  const [crudAction, setCrudAction] = React.useState({
    action: null,
    data: null,
  });
  const { number, setNumber } = useUpdatedContext();
  const [startDate, setStartDate] = useState("2025-05-11");
  const [repeatEvery, setRepeatEvery] = useState(1);
  const [repeatUnit, setRepeatUnit] = useState("week");
  const todayIndex = DateTime.local().weekday % 7; // Luxon: 1=Lunes, 7=Domingo
  const [selectedDays, setSelectedDays] = useState([daysMap[todayIndex]]);
  const [endMode, setEndMode] = useState("after");
  const [endAfter, setEndAfter] = useState(
    (typeof props.finalData.etapaDos !== "undefined" &&
      props.finalData.etapaDos.length === 0) ||
      typeof props.finalData.etapaDos[0].plazo === "undefined"
      ? ""
      : props.finalData.etapaDos[0].plazo
  );
  const [endDate, setEndDate] = useState("2025-08-10");
  const [dates, setDates] = useState([]);
  const [editIndex, setEditIndex] = useState(null);
  const [editValue, setEditValue] = useState("");
  const [showSuccess, setShowSuccess] = useState(false);
  const [confirmChecked, setConfirmChecked] = useState(false);

  const [listadoDePagos, setListadoDePagos] = useState([]);

  const { isLoading, startLoading, stopLoading } = useLoading();

  const toggleDay = (day) => {
    setSelectedDays((prev) =>
      prev.includes(day) ? prev.filter((d) => d !== day) : [...prev, day]
    );
  };

  const generateDates = () => {
    if (selectedDays.length === 0) {
      toast.error(
        "Debes seleccionar al menos un día para generar el calendario de pagos."
      );
      return;
    }
    const result = [];
    let current = DateTime.fromISO(startDate); // Corrección: inicializar como DateTime
    let count = 0;

    while (true) {
      const currentDayLetter = daysMap[current.weekday % 7]; // Luxon: 1 = Lunes, 7 = Domingo
      if (selectedDays.includes(currentDayLetter)) {
        result.push(current.toISODate());
        count++;
      }

      if (endMode === "after" && count >= endAfter) break;
      if (endMode === "until" && current > DateTime.fromISO(endDate)) break;
      if (endMode === "never" && count > 500) break;

      current = current.plus({ days: 1 });
    }

    setDates(result);
    setShowSuccess(true);
    setTimeout(() => setShowSuccess(false), 3000);
  };

  const handleAcceptConfirmation = () => {
    // Aquí va la lógica que deseas ejecutar al confirmar
    startLoading();

    let arrayFinal = {
      idcontrato: props.finalData.etapaUno[0].id,
      fechas: dates,
    };

    postcrearCalendarioDePagos(user, arrayFinal)
      .then((resultado) => {
        if (resultado.status === 200) {
          toast.success("Calendario de pagos creado exitosamente.");
        }
      })
      .finally(() => {
        setNumber(number + 1);
        setDates([]);
        setConfirmChecked(false);
        stopLoading();
      });

    //armando el objeto que vamos a mandar
  };

  React.useEffect(() => {
    startLoading();
    getcrearCalendarioDePagos(user, props.finalData.etapaUno[0].id)
      .then((resultado) => {
        if (resultado.status === 200) {
          // Manejar el resultado aquí
          setListadoDePagos(resultado.data);
        }
      })
      .finally(() => {
        stopLoading();
      });
  }, [number]);

  return (
    <>
      <div
        className="container mt-5 card"
        style={{ backgroundColor: "#ffffff" }}
      >
        <div className=" card-body">
          <div className="row col-12 mb-4">
            <h3>Programar calendario de pagos</h3>
          </div>

          <div className="row">
            <div className="col-md-8">
              {listadoDePagos.length === 0 && (
                <>
                  {/* Formulario */}
                  <div className="mb-3">
                    <label className="form-label">
                      Fecha de inicio:{" "}
                      <small style={{ opacity: 0.7, color: "green" }}>
                        {" "}
                        (Para cambiarlo vaya al apartado de finanzas y cambie la
                        fecha de inicio de pago):
                      </small>
                    </label>
                    <input
                      type="date"
                      className="form-control"
                      disabled={true}
                      value={startDate}
                      onChange={(e) => setStartDate(e.target.value)}
                    />
                  </div>

                  <div className="mb-3 row">
                    <div className="col-md-6">
                      <label className="form-label">Repetir cada:</label>
                      <input
                        type="number"
                        className="form-control"
                        min="1"
                        value={repeatEvery}
                        onChange={(e) =>
                          setRepeatEvery(parseInt(e.target.value))
                        }
                      />
                    </div>
                    <div className="col-md-6">
                      <label className="form-label">Unidad:</label>
                      <select
                        className="form-select"
                        value={repeatUnit}
                        onChange={(e) => setRepeatUnit(e.target.value)}
                      >
                        <option value="day">Día</option>
                        <option value="week">Semana</option>
                      </select>
                    </div>
                  </div>

                  <div className="mb-3">
                    <label className="form-label">Día a repetir:</label>
                    <div className="d-flex gap-2 flex-wrap">
                      {daysMap.map((d) => (
                        <button
                          key={d}
                          type="button"
                          className={`btn btn-sm ${
                            selectedDays.includes(d)
                              ? "btn-primary"
                              : "btn-outline-secondary"
                          }`}
                          onClick={() => toggleDay(d)}
                        >
                          {d}
                        </button>
                      ))}
                    </div>
                  </div>

                  {endMode === "after" && (
                    <div className="mb-3">
                      <label className="form-label">
                        Número de pagos (Plazo):
                      </label>
                      <input
                        type="number"
                        className="form-control"
                        disabled={true}
                        value={endAfter}
                        onChange={(e) => setEndAfter(parseInt(e.target.value))}
                      />
                    </div>
                  )}

                  <div className="mb-3 d-none">
                    <label className="form-label">Finaliza:</label>
                    <select
                      className="form-select"
                      value={endMode}
                      onChange={(e) => setEndMode(e.target.value)}
                    >
                      <option value="after">Después de {endAfter} pagos</option>
                    </select>
                  </div>

                  {endMode === "until" && (
                    <div className="mb-3">
                      <label className="form-label">Fecha de fin:</label>
                      <input
                        type="date"
                        className="form-control"
                        value={endDate}
                        onChange={(e) => setEndDate(e.target.value)}
                      />
                    </div>
                  )}

                  <button
                    className="btn btn-success mb-4 mt-4"
                    onClick={generateDates}
                  >
                    Generar fechas
                  </button>

                  {/* Alerta de éxito */}
                  {showSuccess && (
                    <div className="alert alert-success mt-2" role="alert">
                      ¡Fechas generadas correctamente!, revisa la tabla, haz los
                      ajustes necesarios y guarda los cambios.
                    </div>
                  )}

                  {/* Tabla de fechas generadas */}
                  {dates.length > 0 && (
                    <div className="mt-4">
                      <h5>Calendario de pagos:</h5>
                      <div className="table-responsive">
                        <table className="table table-striped table-bordered">
                          <thead>
                            <tr>
                              <th>#</th>
                              <th>Fecha</th>
                              <th>Día</th>
                              <th>Acción</th>
                            </tr>
                          </thead>
                          <tbody>
                            {dates.map((d, i) => {
                              const date = DateTime.fromISO(d);
                              const isEditing = editIndex === i;
                              return (
                                <tr key={i}>
                                  <td>{i + 1}</td>
                                  <td>
                                    {isEditing ? (
                                      <input
                                        type="date"
                                        className="form-control form-control-sm"
                                        value={editValue}
                                        onChange={(e) =>
                                          setEditValue(e.target.value)
                                        }
                                      />
                                    ) : (
                                      date.toFormat("dd/MM/yyyy")
                                    )}
                                  </td>
                                  <td>{daysMap[date.weekday % 7]}</td>
                                  <td>
                                    {isEditing ? (
                                      <button
                                        className="btn btn-success btn-sm"
                                        onClick={() => {
                                          const newDates = [...dates];
                                          newDates[i] = editValue;
                                          setDates(newDates);
                                          setEditIndex(null);
                                        }}
                                      >
                                        <i className="bi bi-check"></i>{" "}
                                        Confirmar Edición Edición
                                      </button>
                                    ) : (
                                      <button
                                        className="btn btn-success btn-sm"
                                        onClick={() => {
                                          setEditIndex(i);
                                          setEditValue(date.toISODate());
                                        }}
                                      >
                                        <i className="bi bi-pencil"></i> Editar
                                      </button>
                                    )}
                                  </td>
                                </tr>
                              );
                            })}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  )}
                </>
              )}

              {listadoDePagos.length > 0 && (
                <div className="mt-4">
                  <h5>Pagos programados:</h5>
                  <div className="table-responsive">
                    <table className="table table-striped table-bordered">
                      <thead>
                        <tr>
                          <th>#</th>
                          <th>Fecha</th>
                          <th>Serie</th>
                          <th>Folio</th>
                          <th>Pago</th>
                          <th>Estado</th>
                        </tr>
                      </thead>
                      <tbody>
                        {listadoDePagos.map((pago, i) => (
                          <tr key={pago.id}>
                            <td>{i + 1}</td>
                            <td>
                              {(() => {
                                const fecha = DateTime.fromISO(pago.fechaRuta);
                                const diaSemana = daysMap[fecha.weekday % 7];
                                return `${fecha.toFormat(
                                  "dd/MM/yyyy"
                                )} (${diaSemana})`;
                              })()}
                            </td>
                            <td>{pago.cseriecobranza?.serie ?? ""}</td>
                            <td>
                              {pago.cseriecobranza?.folioAutomatico ?? ""}
                            </td>
                            <td>
                              {pago.pago == null
                                ? new Intl.NumberFormat("es-MX", {
                                    style: "currency",
                                    currency: "MXN",
                                  }).format(0)
                                : new Intl.NumberFormat("es-MX", {
                                    style: "currency",
                                    currency: "MXN",
                                  }).format(pago.pago)}
                            </td>
                            <td>
                              {" "}
                              <span
                                className="badge text-bg-success w-100"
                                style={{
                                  backgroundColor:
                                    pago.cestatuscobroapp?.color ?? "#28a745",
                                }}
                              >
                                {pago.cestatuscobroapp?.nombre ?? ""}
                              </span>{" "}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              )}
            </div>

            {/* Columna derecha con explicación */}
            <div className="col-md-4">
              <div className="card">
                <div
                  className="card-header text-white pt-2"
                  style={{ backgroundColor: "#007bff" }}
                >
                  <h5 className="mb-0 mt-2">
                    <IoInformationCircleSharp /> Información{" "}
                  </h5>
                </div>
                <div className="card-body">
                  {listadoDePagos.length === 0 && (
                    <>
                      {" "}
                      <h6>Instrucciones:</h6>
                      <p>
                        Esta ventana permite crear un calendario de pagos
                        recurrentes para el contrato.
                      </p>
                      <ul>
                        <li>
                          <strong>Fecha de inicio:</strong> Se refiere a la
                          fecha de inicio de los pagos.
                        </li>
                        <li>
                          <strong>Repetir cada:</strong> Defina la frecuencia de
                          los pagos, (Catorcena = 14 días, Semana = 7 días,
                          Quincena = 15 días o repetir cada 2 semanas).
                        </li>
                        <li>
                          <strong>Días a repetir:</strong> Seleccione qué días
                          de la semana ocurrirán los pagos.
                        </li>
                        <li>
                          <strong>Número de pagos:</strong> Establezca cuántos
                          pagos se realizarán en total.
                        </li>
                      </ul>
                      <div className="alert alert-warning">
                        <i className="bi bi-exclamation-triangle me-2"></i>
                        Revisa cuidadosamente las fechas generadas antes de
                        finalizar.
                      </div>
                    </>
                  )}

                  {listadoDePagos.length > 0 && (
                    <>
                      {" "}
                      <h6>Listado de pagos:</h6>
                      <p>
                        Este listado ya fue generado y no se puede modificar.
                      </p>
                      <p>
                        Si necesitas realizar cambios, por favor contacta al
                        administrador del sistema.
                      </p>
                    </>
                  )}
                </div>
              </div>
              {dates.length > 0 && (
                <div className="card mt-3">
                  <div
                    className="card-header text-white pt-2"
                    style={{ backgroundColor: "green" }}
                  >
                    <h5 className="mb-0 mt-2">
                      <IoInformationCircleSharp /> Confirmación{" "}
                    </h5>
                  </div>
                  <div className="card-body">
                    <p>
                      Esta ventana permite crear un calendario de pagos
                      recurrentes para el contrato.
                    </p>

                    <div className="alert alert-warning">
                      <i className="bi bi-exclamation-triangle me-2"></i>
                      Revise cuidadosamente las fechas generadas antes de
                      finalizar.
                    </div>
                    <hr />
                    <div className="mb-3">
                      <p className="fw-bold text-danger">
                        Confirmo que la información es correcta y que no podré
                        generar cambios a dicha información.
                      </p>
                      <div className="form-check">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          id="confirmCheck"
                          checked={confirmChecked}
                          onChange={(e) => setConfirmChecked(e.target.checked)}
                        />
                        <label
                          className="form-check-label"
                          htmlFor="confirmCheck"
                        >
                          He leído y acepto la condición anterior
                        </label>
                      </div>
                    </div>
                    {confirmChecked && (
                      <button
                        className="btn btn-success mt-2"
                        onClick={handleAcceptConfirmation}
                      >
                        Aceptar
                      </button>
                    )}
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CalendarioDePagosContratoComponent;
